import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=26583c50&"
import script from "./Packaging.vue?vue&type=script&lang=js&"
export * from "./Packaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports